const authentication = require('../../../react-azure-adb2c2').default;



export const list = (value: any) => {
    // let url = `http://localhost:5000/api/v1/rent/contracts/contractconfirm`;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/contractconfirm`;

    const token = authentication.getAccessToken();
    // alert(url)
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(value),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};











export const detail = (Id: number) => {

    const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + Id;

    const token = authentication.getAccessToken();

    return fetch(url, {
        headers: { 'Authorization': 'Bearer ' + token }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}



export const update = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts`;
    // let url = `http://localhost:5000/api/v1/rent/contracts`;

    return fetch(url, {
        method: 'put',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res)
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}

